export class EditorRange {
  constructor(range) {
    this.range = range || null;
  }

  static fromSelection() {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return null;
    return new EditorRange(sel.getRangeAt(0));
  }

  get native() {
    return this.range;
  }

  isCollapsed() {
    return !!this.range?.collapsed;
  }

  clone() {
    if (!this.range) return null;
    return new EditorRange(this.range.cloneRange());
  }

  select() {
    if (!this.range) return;
    const sel = window.getSelection();
    if (!sel) return;
    sel.removeAllRanges();
    sel.addRange(this.range);
  }

  surround(node) {
    if (!this.range) return;
    this.range.surroundContents(node);
  }

  deleteContents() {
    this.range?.deleteContents();
  }

  insertNode(node) {
    this.range?.insertNode(node);
  }

  collapse(toStart = false) {
    this.range?.collapse(toStart);
  }
}
